import {useSelector} from "react-redux";
import {selectUser} from "#store/slices/authSlice";

const useAuth = () => {
  return useSelector(selectUser)
}
export default useAuth;